import { Inbox } from 'lucide-react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { useRoomRequests } from '~/entities/room-request/model/use-room-requests'
import * as m from '~/paraglide/messages'
import { Badge } from '~/shared/ui/badge'

/** The number of requests an event on request still has to answer; nothing when none wait. */
export function OpenRequestsBadge({ eventId }: { eventId: string }) {
  const { data: business } = useCurrentBusiness()
  const requests = useRoomRequests(business?.id ?? '', eventId, 'pending')
  const open = requests.data?.counts.pending ?? 0
  if (open === 0) return null

  const label = m.openRequestsLabel({ count: String(open) })
  return (
    <Badge className="gap-1 whitespace-nowrap" title={label} aria-label={label}>
      <Inbox className="size-3" />
      {open}
    </Badge>
  )
}
